import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";
import { toast } from "sonner";

export default function ResetPassword() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("Mínimo 8 caracteres"); return; }
    if (pw !== pw2) { toast.error(t("reset.mismatch")); return; }
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success(t("reset.success"));
      nav("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setSubmitting(false); }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-white flex flex-col">
        <div className="p-6"><Link to="/"><Logo /></Link></div>
        <div className="flex-1 flex items-center justify-center px-4">
          <div className="w-full max-w-md p-8 bg-[#F9FAFB] border border-gray-200 rounded-2xl text-center">
            <h1 className="text-xl font-bold text-[#0B0B0B]">Token faltante</h1>
            <p className="mt-2 text-sm text-gray-600">Solicita un nuevo link desde <Link to="/olvide-password" className="text-[#F26A21]">Olvidé mi contraseña</Link>.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="p-6"><Link to="/"><Logo /></Link></div>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md p-8 bg-[#F9FAFB] border border-gray-200 rounded-2xl">
          <h1 className="text-2xl font-bold text-[#0B0B0B] font-display">{t("reset.heading")}</h1>
          <p className="mt-2 text-sm text-gray-600">{t("reset.sub")}</p>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
            <label className="block">
              <span className="text-[11px] font-semibold uppercase tracking-widest text-gray-600">{t("reset.newPassword")}</span>
              <input required type="password" value={pw} minLength={8} onChange={(e) => setPw(e.target.value)}
                data-testid="reset-password"
                className="w-full mt-1 bg-white border border-gray-300 rounded-md px-3 py-2 text-sm text-[#0B0B0B] focus:outline-none focus:border-[#F26A21]" />
            </label>
            <label className="block">
              <span className="text-[11px] font-semibold uppercase tracking-widest text-gray-600">{t("reset.confirm")}</span>
              <input required type="password" value={pw2} minLength={8} onChange={(e) => setPw2(e.target.value)}
                data-testid="reset-confirm"
                className="w-full mt-1 bg-white border border-gray-300 rounded-md px-3 py-2 text-sm text-[#0B0B0B] focus:outline-none focus:border-[#F26A21]" />
            </label>
            <button type="submit" disabled={submitting} data-testid="reset-submit"
              className="w-full py-3 rounded-md bg-[#F26A21] hover:bg-[#D9541A] text-[#0B0B0B] font-semibold disabled:opacity-60">
              {submitting ? "..." : t("reset.submit")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
